<template>
    <div style="background: #FFF;height: 100%;">
        <div v-if="!Object.keys(orderCode).length && !promptlyfinish_"
            :style="[' margin: 0 auto; padding-bottom: .24rem;background-color: #FFF;', flag ? '' : 'padding-top: 0.7rem;width: 12.8rem;']">
            <div v-if="!flag" style=" font-size: .2rem; color: #333333; font-weight: 400;margin-top: .24rem;">
                <span>确认订单信息</span>
            </div>
            <div style="margin-top: .2rem;display: flex;column-gap: 40px;">
                <!-- left -->
                <div style="flex: 1;">
                    <div style="display: flex;border: 1px solid #E5E6EB;border-radius: 4px;">
                        <div v-if="loading" style="padding: .24rem;flex: 1;">
                            <el-skeleton :rows="4" />
                        </div>
                        <div v-if="!loading" style="flex: 1;">
                            <div
                                style="color: #333333; font-size: .14rem; font-weight: 400;width: 100%;background: #e3e6ec;height: 0.37rem;line-height: 0.37rem;padding-left: .2rem;">
                                <span>商品信息</span>
                            </div>
                            <div style="padding: .12rem;display: flex;align-items: center;column-gap: .12rem;">
                                <div style="height: .94rem;width: 1.58rem;border-radius: .08rem;">
                                    <!-- <img src="" alt="" srcset=""> -->
                                    <img style="height: .94rem;width: 1.58rem;border-radius: .08rem;"
                                        :src="detailData.image" alt="" srcset="">
                                </div>
                                <div style="display: flex;flex-direction: column;row-gap: .08rem;">
                                    <div style=" color: #333333; font-size: .14rem;"><span>{{ detailData.title }}</span>
                                    </div>
                                    <div style="  color: #86909c; font-size: .12rem;">
                                        <span>{{ detailData.content }}</span>
                                    </div>
                                    <div>
                                        <span style=" color: #86909c; font-size: .14rem;">单价:</span>
                                        <span style="  color: #333333; font-size: .14rem;margin-left: 8px;">￥{{
                                            detailData.price }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!loading" style="width:1.5rem;display: flex;flex-direction: column;">
                            <div
                                style="color: #333333; font-size: .14rem; font-weight: 400;width: 100%;background: #e3e6ec;height: 0.37rem;line-height: 0.37rem;">
                                <span>详情</span>
                            </div>
                            <div style="flex: 1;display: flex;align-items: center;">
                                <span>{{ detailData.type == 1 ? '线上课程' : '线下课程' }}</span>
                            </div>
                        </div>
                        <div v-if="!loading" style="width:1.5rem;display: flex;flex-direction: column;">
                            <div
                                style="color: #333333; font-size: .14rem; font-weight: 400;width: 100%;background: #e3e6ec;height: 0.37rem;line-height: 0.37rem;">
                                <span>价格</span>
                            </div>
                            <div style="flex: 1; color: #c01a26; font-size: .14rem;display: flex;align-items: center;">
                                <span>￥{{ detailData.price }}</span>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div style=" color: #333333; font-size: .16rem;margin-top: .2rem;">
                        <span>发票信息</span>
                    </div>
                    <div
                        style=" color: #333333; font-size: 14px;height: .41rem;background: #F2F3F5;border-radius: 8px;line-height: .41rem;padding-left: .16rem;margin-top: .12rem;">
                        <span>购买后可开具发票</span>
                    </div>
                </div>
                <!-- right -->
                <div style="border: 1px solid #E5E6EB;border-radius: 4px;padding: .24rem;">
                    <el-skeleton :rows="7" v-if="loading" style="width: 2.4rem;" />
                    <div v-if="!loading" style="display: flex;justify-content: space-between;align-items: center;">
                        <div style=" color: #86909c; font-size: 14px; font-weight: 400;"><span>商品价格：</span></div>
                        <div style=" font-size: 14px; color: #333333;"><span>￥{{ detailData.price }}</span></div>
                    </div>
                    <div v-if="!loading"
                        style="display: flex;justify-content: space-between;align-items: center;margin-top: .2rem;">
                        <div style=" color: #86909c; font-size: 14px; font-weight: 400;"><span>应付金额：</span></div>
                        <div style=" font-size: 20px; color: #C01A26;"><span>￥{{ detailData.price }}</span></div>
                    </div>
                    <div v-if="!loading && (detailData.orderState == 1 || detailData.orderState == 3 || detailData.orderState == null)"
                        @click="orderBtn"
                        style="height: .45rem;background: #C01A26;width: 100%;border-radius: 8px;line-height: .45rem;text-align: center;color: #FFF;margin-top: .3rem;cursor: pointer;">
                        <span>{{ detailData.orderState == 1 ? '立即支付' : '立即下单' }}</span>
                    </div>
                    <div v-if="!loading" style=" font-size: 12px;margin-top: .26rem;">
                        <span style=" color: #86909c;">购买即代表你已同意</span>
                        <span style=" color: #c01a26;cursor: pointer;"
                            @click="router.push('/agreement?name=sfdlsqxy')">《培训及服务协议》</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="Object.keys(orderCode).length && !promptlyfinish_"
            :style="[' margin: 0 auto; padding-top: 0.7rem;padding-bottom: .24rem;background-color: #FFF;', flag ? '' : 'width: 12.8rem;']">
            <div v-if="!flag" style=" font-size: .2rem; color: #333333; font-weight: 400;margin-top: .24rem;">
                <span>收银台</span>
            </div>
            <div style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <div><img style="width: .48rem;height: .48rem;" src="@/assets/3.png" alt="" srcset=""></div>
                <div style=" font-size: 14px; font-weight: 400;margin-top: .16rem;"><span>订单提交成功，请尽快完成付款!</span></div>
                <div
                    style="margin-top: .04rem; color: #86909c; font-size: 14px; font-weight: 400;display: flex;align-items: center;column-gap: 15px;">
                    <div><span>订单号：{{ orderCode.orderSn }}</span></div>
                    <div style=" color: #c01a26; font-size: 14px;"><span>{{ timer }}</span>
                    </div>
                    <div><span>后订单将自动关闭</span></div>
                </div>
                <div style="margin-top: .26rem;">
                    <span style=" color: #000000; font-size: 14px;">应付金额：</span>
                    <span style=" color: #c01a26; font-size: 24px;">￥{{ detailData.price }}</span>
                </div>
            </div>
            <div
                style="background: #F2F3F5;border-radius: 8px;padding: .24rem;margin-top: .4rem;display: flex;row-gap: .12rem;flex-direction: column;">
                <div style=" color: #000000; font-size: 14px;">
                    <span style="width: 70px;display: inline-block;">收货人：</span>
                    <span style="margin-left: 15px;">{{ name_c }}</span>
                </div>
                <div style=" color: #000000; font-size: 14px;">
                    <span style="width: 70px;display: inline-block;">收款方：</span>
                    <span style="margin-left: 15px;">标识山西</span>
                </div>
                <div style=" color: #000000; font-size: 14px;">
                    <span style="width: 70px;display: inline-block;">商品信息：</span>
                    <span style="margin-left: 15px;">{{ orderCode.productName || orderCode.courseName }}</span>
                </div>
            </div>
            <div style="margin-top: .24rem;">
                <div style=" color: #000000; font-size: 14px;"><span>选择支付方式</span></div>
                <div style="display: flex;align-items: center;column-gap: .12rem;margin-top: .12rem;">
                    <div @click="!promptlyShow && (iszf = 'WXPAY')"
                        :style="['border-radius: 4px;width: .96rem;height: .4rem;display: flex;align-items: center;column-gap: 5px;justify-content: center;cursor: pointer;position: relative;', iszf == 'WXPAY' ? 'border: 1px solid #2978FF;' : 'border: 1px solid #E5E6EB;']">
                        <div><img style="width: .24rm;height: .24rem;" src="@/assets/4.png" alt="" srcset=""></div>
                        <div style=" color: #333333; font-size: 14px;"><span>微信</span></div>
                        <div v-if="iszf == 'WXPAY'" style="position: absolute;bottom: -1px;right: -1px;">
                            <img style="width: .23rem;height: .19rem;" src="@/assets/6.png" alt="" srcset="">
                        </div>
                    </div>
                    <div @click="!promptlyShow && (iszf = 'ALIPAY')"
                        :style="['border-radius: 4px;width: .96rem;height: .4rem;display: flex;align-items: center;column-gap: 5px;justify-content: center;cursor: pointer;position: relative;', iszf == 'ALIPAY' ? 'border: 1px solid #2978FF;' : 'border: 1px solid #E5E6EB;']">
                        <div><img style="width: .24rm;height: .24rem;" src="@/assets/5.png" alt="" srcset=""></div>
                        <div style=" color: #333333; font-size: 14px;"><span>支付宝</span></div>
                        <div v-if="iszf == 'ALIPAY'" style="position: absolute;bottom: -1px;right: -1px;">
                            <img style="width: .23rem;height: .19rem;" src="@/assets/6.png" alt="" srcset="">
                        </div>
                    </div>
                </div>
            </div>
            <two-dimensional-code v-if="promptlyShow" ref="TwoDimensionalCodeRef" :CloseQrCode="CloseQrCode"
                :timterClose="timterClose" />
            <div v-if="!promptlyShow" style="display: flex;justify-content: center;margin-top: .4rem;cursor: pointer;">
                <div @click="promptlyBtn"
                    style="height: .45rem;line-height: .45rem;background: #C01A26;border-radius: 8px;color: #FFF;text-align: center;width: 2.68rem;">
                    <span>立即支付</span>
                </div>
            </div>
        </div>
        <div v-else-if="!flag && promptlyfinish_"
            :style="[' margin: 0 auto; padding-top: 0.7rem;padding-bottom: .24rem;background-color: #FFF;', flag ? '' : 'width: 12.8rem;']">
            <finish_ :orderData="orderCode" />
        </div>
        <div v-else>

        </div>
    </div>
</template>
<script setup>
import { ref, nextTick, onBeforeUnmount } from 'vue'
import { useRouter } from "vue-router"
import { Axios } from "../../assets/js/ls_com_axios.js";
import TwoDimensionalCode from "./zf";
import finish_ from "./finish_"
import { ElMessageBox, ElMessage } from "element-plus"
const urlData = new URLSearchParams(location.search);
const TwoDimensionalCodeRef = ref();
let name_c = ref(JSON.parse(localStorage.getItem("userList")).nickName)
const props_ = defineProps(['flag', 'ruleForm_Val'])
const edmit = defineEmits(['click', 'signUpSubmit'])
const detailData = ref({});
const loading = ref(true);
const router = useRouter();
const iszf = ref("WXPAY");
const getList = () => {
    loading.value = true;
    Axios(
        "get",
        "/system/courseWeb/catalogue",
        {
            courseId: urlData.get('id')
        },
        false,
        (res) => {
            detailData.value = res.data.data;
            loading.value = false;
        },
        () => {
            loading.value = false;
            detailData.value = {};
        })
}
getList()
let time = ref();
const timer = ref("00:00:00");
const formatDate = () => {
    time.value && clearInterval(time.value);
    time.value = setInterval(() => {
        let s = orderCode.value.orderEndTime - new Date().getTime();
        if (s <= 0) {
            clearInterval(time.value);
            getList()
            orderCode.value = {};
            return
        }
        const data = new Date(s);
        const minutes = data.getMinutes();
        const seconds = data.getSeconds();
        timer.value = `00:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
    }, 1000)

}


const orderCode = ref(urlData.get("orData") ? JSON.parse(decodeURIComponent(urlData.get("orData"))) : {});
console.log(orderCode.value)
urlData.get("orData") && formatDate();
onBeforeUnmount(() => {
    time.value && clearInterval(time.value);
})
const signUpSubmit = (val) => {
    Axios(
        "post",
        "/system/courseWeb/signUp",
        {
            ...props_.ruleForm_Val.value,
            courseId: detailData.value.courseId
        },
        false,
        (res) => {
            if (res.data.code == 200) {
                Axios(
                    "get",
                    "/system/courseWeb/commitOrder",
                    {
                        courseId: detailData.value.courseId
                    },
                    false,
                    (res) => {
                        if (res.data.code == 200) {
                            orderCode.value = res.data.data;
                            formatDate()
                            edmit('click', 2)
                        } else {
                            orderCode.value = {}
                            ElMessage.error(res.data.msg)
                        }
                    }, () => {
                        orderCode.value = {}
                    })
            }
        },
        () => {

        })
}
const orderBtn = () => {
    if (detailData.value.orderState == 1) {
        router.push('/myCourse?id=' + detailData.value.courseId)
        return
    }
    ElMessageBox.confirm(
        '是否确认下单？',
        '',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'orderDetail',
            confirmButtonClass: "",
            center: true,
            closeOnClickModal: false
        }
    )
        .then(() => {
            console.log(detailData.value)
            detailData.value.type == 1 ? Axios(
                "get",
                "/system/courseWeb/commitOrder",
                {
                    courseId: detailData.value.courseId
                },
                false,
                (res) => {
                    if (res.data.code == 200) {
                        orderCode.value = res.data.data;
                        formatDate()
                        edmit('click', 2)
                    } else {
                        orderCode.value = {}
                        ElMessage.error(res.data.msg)
                    }
                }, () => {
                    orderCode.value = {}
                }) : signUpSubmit()
            // signUpSubmit()
        }).catch(() => {

        })
}
const promptlyShow = ref(false);
const promptlyfinish_ = ref(false);
const timterClose = () => {
    promptlyShow.value = false;
}
const promptlyBtn = () => {
    Axios(
        "post",
        `/system/courseWeb/create-pay/${iszf.value}/${orderCode.value.orderId || orderCode.value.id}`,
        {

        },
        false,
        (res) => {
            promptlyShow.value = true;
            nextTick(() => {
                TwoDimensionalCodeRef.value.init(
                    res.data.data.qrcode,
                    res.data.data.sceneId,
                );
            })
        }, () => {
            promptlyShow.value = false;
        })
}
const CloseQrCode = () => {
    promptlyfinish_.value = true;
    time.value && clearInterval(time.value);
    edmit('click', 4, orderCode.value)
}
</script>
<style lang="less">
.orderDetail .el-message-box__title {
    font-size: 60px !important;
    padding-left: 25px !important;
}

.orderDetail {
    border-radius: 12px !important;
}

.orderDetail .el-message-box__btns {
    button {
        width: 88px !important;
        line-height: 32px !important;
        text-align: center;
        line-height: 32px;
    }
}

.orderDetail .el-button--primary {
    background: #C01A26;
    border: 1px solid #C01A26;
}

.orderDetail .el-button:focus-visible {
    outline: 2px solid #C01A26;
}

.orderDetail .el-message-box__headerbtn:focus .el-message-box__close,
.el-message-box__headerbtn:hover .el-message-box__close {
    color: #C01A26;
}
</style>